<div class="form-group">
  <div class="dropdown">
    <button aria-expanded="false" aria-haspopup="true" class="bootstrap-select btn btn-secondary dropdown-toggle"
      data-toggle="dropdown" id="dropdownMenu2" type="button">
      <span class="filter-option">{{displayText}}</span>
      <span class="pull-left"></span>
    </button>
    <div aria-labelledby="dropdownMenu2" class="dropdown-menu">
      <ul aria-expanded="true" class="dp" role="listbox" style="max-height: 450px; overflow-y: auto;">
        <li *ngFor="let v of valueDropdown" (click)="onSelectValue(v)" class="dropdown-item" data-original-index="1">
          <a aria-disabled="false" aria-selected="false" class="" data-tokens="null" role="option" ta-tokens="null"
            tabindex="0">
            <span class="text">{{v.value}}</span>
            <span class="glyphicon glyphicon-ok check-mark"></span>
          </a></li>
      </ul>
    </div>
  </div>
</div>